export default "__VITE_ASSET__Cyl4lxW2__"